import React from 'react';
import { useTranslation } from 'react-i18next';

const Terms = () => {
  const { t } = useTranslation();

  return (
    <>
      <head>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
      </head>
      <section className="page-header">
        <div className="container">
          <h1>{t('terms.title')}</h1>
          <p>{t('terms.last_updated')}</p>
        </div>
      </section>

      <section className="page-content">
        <div className="container">
          <div className="content-section">
            <h2>{t('terms.agreement.title')}</h2>
            <p>{t('terms.agreement.text1')}</p>
            <p>{t('terms.agreement.text2')}</p>
          </div>

          <div className="content-section">
            <h2>{t('terms.services.title')}</h2>
            <p>{t('terms.services.text')}</p>
            <ul>
              {(t('terms.services.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <p>{t('terms.services.disclaimer')}</p>
          </div>

          <div className="content-section">
            <h2>{t('terms.client_responsibilities.title')}</h2>
            <h3>{t('terms.client_responsibilities.project_requirements.title')}</h3>
            <p>{t('terms.client_responsibilities.project_requirements.text')}</p>
            <ul>
              {(t('terms.client_responsibilities.project_requirements.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>

            <h3>{t('terms.client_responsibilities.content_materials.title')}</h3>
            <p>{t('terms.client_responsibilities.content_materials.text')}</p>
            <ul>
              {(t('terms.client_responsibilities.content_materials.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="content-section">
            <h2>{t('terms.payment_terms.title')}</h2>
            <h3>{t('terms.payment_terms.pricing.title')}</h3>
            <p>{t('terms.payment_terms.pricing.text')}</p>
            
            <h3>{t('terms.payment_terms.payment_methods.title')}</h3>
            <p>{t('terms.payment_terms.payment_methods.text')}</p>
            
            <h3>{t('terms.payment_terms.late_payments.title')}</h3>
            <p>{t('terms.payment_terms.late_payments.text')}</p>
            <ul>
              {(t('terms.payment_terms.late_payments.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            
            <h3>{t('terms.payment_terms.refunds.title')}</h3>
            <p>{t('terms.payment_terms.refunds.text')}</p>
          </div>

          <div className="content-section">
            <h2>{t('terms.intellectual_property.title')}</h2>
            <h3>{t('terms.intellectual_property.client_materials.title')}</h3>
            <p>{t('terms.intellectual_property.client_materials.text')}</p>
            
            <h3>{t('terms.intellectual_property.work_product.title')}</h3>
            <p>{t('terms.intellectual_property.work_product.text')}</p>
            
            <h3>{t('terms.intellectual_property.molecorp_ip.title')}</h3>
            <p>{t('terms.intellectual_property.molecorp_ip.text')}</p>
            <ul>
              {(t('terms.intellectual_property.molecorp_ip.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="content-section">
            <h2>{t('terms.confidentiality.title')}</h2>
            <p>{t('terms.confidentiality.text')}</p>
            <ul>
              {(t('terms.confidentiality.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <p>{t('terms.confidentiality.survival')}</p>
          </div>

          <div className="content-section">
            <h2>{t('terms.project_timeline.title')}</h2>
            <h3>{t('terms.project_timeline.timeline.title')}</h3>
            <p>{t('terms.project_timeline.timeline.text')}</p>
            <ul>
              {(t('terms.project_timeline.timeline.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            
            <h3>{t('terms.project_timeline.deliverables.title')}</h3>
            <p>{t('terms.project_timeline.deliverables.text')}</p>
            <ul>
              {(t('terms.project_timeline.deliverables.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="content-section">
            <h2>{t('terms.warranties.title')}</h2>
            <h3>{t('terms.warranties.service_warranty.title')}</h3>
            <p>{t('terms.warranties.service_warranty.text')}</p>
            
            <h3>{t('terms.warranties.disclaimers.title')}</h3>
            <p>{t('terms.warranties.disclaimers.text')}</p>
            
            <h3>{t('terms.warranties.third_party.title')}</h3>
            <p>{t('terms.warranties.third_party.text')}</p>
          </div>

          <div className="content-section">
            <h2>{t('terms.limitation_liability.title')}</h2>
            <p>{t('terms.limitation_liability.text1')}</p>
            <p>{t('terms.limitation_liability.text2')}</p>
            <ul>
              {(t('terms.limitation_liability.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="content-section">
            <h2>{t('terms.indemnification.title')}</h2>
            <p>{t('terms.indemnification.text')}</p>
            <ul>
              {(t('terms.indemnification.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="content-section">
            <h2>{t('terms.termination.title')}</h2>
            <h3>{t('terms.termination.client_termination.title')}</h3>
            <p>{t('terms.termination.client_termination.text')}</p>
            
            <h3>{t('terms.termination.molecorp_termination.title')}</h3>
            <p>{t('terms.termination.molecorp_termination.text')}</p>
            <ul>
              {(t('terms.termination.molecorp_termination.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            
            <h3>{t('terms.termination.effect.title')}</h3>
            <p>{t('terms.termination.effect.text')}</p>
            <ul>
              {(t('terms.termination.effect.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="content-section">
            <h2>{t('terms.force_majeure.title')}</h2>
            <p>{t('terms.force_majeure.text')}</p>
          </div>

          <div className="content-section">
            <h2>{t('terms.governing_law.title')}</h2>
            <h3>{t('terms.governing_law.applicable_law.title')}</h3>
            <p>{t('terms.governing_law.applicable_law.text')}</p>
            
            <h3>{t('terms.governing_law.dispute_resolution.title')}</h3>
            <p>{t('terms.governing_law.dispute_resolution.text')}</p>
            <ul>
              {(t('terms.governing_law.dispute_resolution.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            
            <h3>{t('terms.governing_law.us_compliance.title')}</h3>
            <p>{t('terms.governing_law.us_compliance.text')}</p>
            <ul>
              {(t('terms.governing_law.us_compliance.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="content-section">
            <h2>{t('terms.us_provisions.title')}</h2>
            <h3>{t('terms.us_provisions.consumer_protection.title')}</h3>
            <p>{t('terms.us_provisions.consumer_protection.text')}</p>
            <ul>
              {(t('terms.us_provisions.consumer_protection.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            
            <h3>{t('terms.us_provisions.change_notifications.title')}</h3>
            <p>{t('terms.us_provisions.change_notifications.text')}</p>
          </div>

          <div className="content-section">
            <h2>{t('terms.general_provisions.title')}</h2>
            <h3>{t('terms.general_provisions.entire_agreement.title')}</h3>
            <p>{t('terms.general_provisions.entire_agreement.text')}</p>
            
            <h3>{t('terms.general_provisions.modifications.title')}</h3>
            <p>{t('terms.general_provisions.modifications.text')}</p>
            
            <h3>{t('terms.general_provisions.severability.title')}</h3>
            <p>{t('terms.general_provisions.severability.text')}</p>
            
            <h3>{t('terms.general_provisions.waiver.title')}</h3>
            <p>{t('terms.general_provisions.waiver.text')}</p>
            
            <h3>{t('terms.general_provisions.assignment.title')}</h3>
            <p>{t('terms.general_provisions.assignment.text')}</p>
          </div>

          <div className="content-section">
            <h2>{t('terms.contact_info.title')}</h2>
            <p>{t('terms.contact_info.text')}</p>
            <ul>
              <li><strong>Correo Electrónico:</strong> legal@molecorp.club</li>
              <li><strong>Dirección:</strong> MoleCorp, Presa Encimera, 48800 Balmaseda, España</li>
              <li><strong>CIF:</strong> B02789345</li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default Terms;